"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeChar = exports.insertAt = void 0;
const insertAt = (des, s, pos) => {
    return [des.slice(0, pos), s, des.slice(pos)].join("");
};
exports.insertAt = insertAt;
const removeChar = (s, pos) => {
    return [s.slice(0, pos), s.slice(pos + 1)].join("");
};
exports.removeChar = removeChar;
